function cov_2rmal96wrl() {
  var path = "/app/src/components/logo/components/logo-en-white-on-green/index.ts";
  var hash = "1fcb8612419701288a14d9f7f72ad0570ac2bf8f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-white-on-green/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1fcb8612419701288a14d9f7f72ad0570ac2bf8f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2rmal96wrl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2rmal96wrl();
export { LogoEnWhiteOnGreen } from './logo-en-white-on-green';